import './MySearch.scss'

import {Component, Fragment} from 'react'

import {prepareFreelanceBeforeSubmit} from '../../../../../shared/services/freelanceService'
import {prepareUserBeforeSubmit} from '../../../../../shared/services/userService'
import CardRow from "../../../../../shared/components/Styled/Card/CardRow.jsx"
import CardCol from "../../../../../shared/components/Styled/Card/CardCol.jsx"

import ProfileVisibilityForm from "../../../../components/Forms/MySearchForms/ProfileVisibilityForm.jsx"
import AvailabilityDateForm from "../../../../components/Forms/MySearchForms/AvailabilityDateForm.jsx"
import api from "../../../../../api.js"
import {Prompt} from "react-router-dom"
import {toastr} from "react-redux-toastr"
import {connect} from "react-redux"
import {getFormValues, isDirty} from "redux-form"
import {generate} from "../../../../routes.js"
import MustBeAdminOrBmOrCompletedFreelance from "../../../../components/Must/MustBeAdminOrBmOrCompletedFreelance.jsx"

import CdiStatusForm from "../../../../components/Forms/MySearchForms/CdiStatusForm.jsx"
import submitUser from "../../submit.js"
import connectModal from "../../../../../shared/components/Modals/connect.js"
import SimpleModal from "../../../../../shared/components/Modals/SimpleModal/SimpleModal.jsx"
import MySearchExtraForm, {name as MySearchExtraFormName} from "../../../../components/Forms/MySearchForms/MySearchExtraForm.jsx"
import MySearchExtraFormSubmitButton
  from "../../../../components/Forms/MySearchForms/MySearchExtraFormSubmitButton.jsx"

class MySearch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      extraFormInitialValues: {
        user: this.props.user
      },
      isCdi: props.freelance.cdi
    }
  }

  componentDidMount() {
    const {props} = this
    if(props?.link?.menu !== 'search.view') {
      this.refreshUser()
    }
  }

  refreshUser = async () => {
    const {refresh, freelance: freelanceProps} = this.props
    if(!freelanceProps  && !freelanceProps?.id) {
      return
    }
    const freelance = (await api.freelances.getOne({freelance: freelanceProps?.id})).data

    refresh({
      user: {...this.props.user, ...freelance.user},
      freelance: {...this.props.freelance, ...freelance},
    })

    this.setState( {
      extraFormInitialValues: {
        user: this.props.user,
        freelance: this.props.freelance,
      },
      isCdi: freelance.cdi
    })
  }

  isDirty = () => {
    return this.props.mySearchExtraFormIsDirty
  }

  submit = (values) => {
    this.props.submit({
      user: prepareUserBeforeSubmit(values.user),
      freelance: this.prepareFreelance(values.freelance)
    }).then((response) => {
      console.info({response})
    }).catch((error) => console.error({error}) )
  }

  prepareFreelance = (freelance) => {
    return {
      ...prepareFreelanceBeforeSubmit(freelance),
    }
  }

  submitUserData = async (data) => {
    if(data) {
      await submitUser({
        ...data,
        user: this.props?.user?.id
      }).then(() => {
        this.setState({
          extraFormInitialValues: {
            ...this.state.extraFormInitialValues,
            user: this.props.mySearchExtraFormValues.user
          }
        })
      }).catch((error) => console.error({error}))
    }
  }
  submitFreelanceData = async (data) => {
    const {freelance} = this.props
    const agentId = freelance?.agent?.id ?? undefined

    const freelanceData = {
      ...data,
      ...((agentId)? {agent: agentId}: {}),
      freelance: this.props?.freelance?.id,
    }

    return await api.freelances.edit(freelanceData)
      .then(() => {
        this.setState({
          extraFormInitialValues: {
            ...this.state.extraFormInitialValues,
            freelance: this.props.mySearchExtraFormValues.freelance
          },
        })
        toastr.success('La disponibilité a été modifiée avec succès')
        return true
      })
      .catch((error) => {
        console.error({error})

        if(error && error.data && error.data.errors ) {
          const msg = error.data.errors
            .map((err) => {
              if (err.message) {
                return err.message
              }
              return undefined
            })
            .filter((errMsg) => {return !!errMsg})
            .join('\n')

          toastr.error(`${msg}`)
          return false
        }

        toastr.error('Une erreur est survenue à la modification de la disponibilité')
        return false
      })
  }

  handleDateChange = (isoStrDate) => {
    this.submitFreelanceData({date_available: isoStrDate,})
  }

  handlePublicVisibilityChange = async (event, value) => {
    return await this.submitFreelanceData({public: value,})
  }

  handleCdiStatusChange = async (freelanceValues, userValues) => {
    await this.submitUserData(userValues)
    if(freelanceValues.cdi) {
      freelanceValues['public'] = false
    } else {
      freelanceValues['date_available'] = new Date().toISOString()
    }
    await this.submitFreelanceData(freelanceValues)
      .then(() => {
        (freelanceValues.cdi) ? this.openCdiSimpleModal() : this.openNotInCdiSimpleModal()
      })
    this.setState({isCdi: freelanceValues.cdi})
  }

  openCdiSimpleModal = () => {
    this.props.openSimpleModal({
      header: 'Je suis en CDI',
      body: <CardRow direction="column">
        <CardCol p="0 25px" gap="0" >
          <p className="dashboard-card-col-txt">
            Votre profil a bien été qualifié en CDI, vous ne recevrez plus de communication directe (mail & SMS) de la part de Twineeds.{' '}
            Nous vous recontacterons une fois par an maximum afin d'actualiser votre situation.{' '}
            Vous pouvez également requalifier votre profil en consultant à l'aide du même bouton.
          </p>
          <p className="dashboard-card-col-txt">A bientôt !</p>
        </CardCol>
      </CardRow>,
    })
  }

  openNotInCdiSimpleModal = () => {
    this.props.openSimpleModal({
      header: 'Je ne suis plus en CDI',
      body: <CardRow direction="column">
        <CardCol p="0 25px" gap="0" >
          <p className="dashboard-card-col-txt">
            Votre profil n'est plus en CDI !
          </p>
          <p className="dashboard-card-col-txt">
            Par défaut :
          </p>
          <ul>
            <li className="dashboard-card-col-txt">
              Vous êtes à nouveau visible pour nos clients. Vous pouvez  modifier ce paramètre sur cette page si vous le souhaitez.
            </li>
            <li className="dashboard-card-col-txt">
              Vous allez recevoir nos offres de missionspar mail et SMS,{' '}
              <a href={generate({name: 'edit-freelance.alertes'})}>cliquez-ici</a>{' '}
              si vous souhaitez modifier vos notifications.
            </li>
          </ul>
        </CardCol>
      </CardRow>,
    })
  }


  render() {
    const {freelance, user} = this.props

    return (
      <div className={"dashboard-layout"}>
        <Prompt when={this.isDirty()}
          message="Des modifications sont en cours êtes vous sûre de vouloir quitter sans sauvegarder ?"/>
        <div className="my-search-container p-5">
          <h2 className="text-center mb-4">Ma recherche</h2>

          <CardRow id="visibility" direction="column" gap="20px">
            <CardCol>
              <CardRow className="my-search-container-row" gap="20px">
                <CardCol flex="1 1 50%">
                  <p className="title">Consultant VS CDI</p>
                  <p className="txt">
                    Indiquez sur votre profil si :
                  </p>
                  <ul>
                    <li className="txt">
                        vous êtes actuellement (ou prochainement) en CDI
                    </li>
                    <li className="txt">
                        vous êtes disposé (ou bientôt disposé) à effectuer des missions en tant que consultant
                    </li>
                  </ul>
                  <CdiStatusForm
                    handleCdiStatusChange={this.handleCdiStatusChange}
                    enableReinitialize={true}
                    initialValues={{
                      freelance,
                      user,
                    }}/>
                </CardCol>

                <CardCol flex="1 1 50%">
                  <p className="title">Visibilité de profil</p>
                  {freelance.cdi ?
                    <p className="txt">
                      Votre profil est actuellement masqué car vous êtes qualifié en CDI.{' '}
                      Vous pouvez modifier cette information en passant votre statut en "consultant" à l'aide de la section "Consultant VS CDI".
                    </p> :
                    <Fragment>
                      <p className="txt">Vous souhaitez masquer votre profil ou le rendre public pour nos clients.</p>
                      <br/>
                      <p className="txt">
                        <strong>Attention !</strong> un profil masqué est uniquement visible par Twineeds et ne reçoit plus de missions par mail & SMS
                      </p>
                    </Fragment>
                  }
                  <ProfileVisibilityForm
                    handlePublicVisibilityChange={this.handlePublicVisibilityChange}
                    enableReinitialize={true}
                    initialValues={
                      {
                        freelance: {
                          ...freelance,
                          revertPublic: !freelance.public,
                        },
                        disabled: this.state.isCdi
                      }}
                    disabled={this.state.isCdi}
                  />
                </CardCol>
              </CardRow>
            </CardCol>

            <CardCol id="availibility">
              <CardRow className="my-search-container-row" gap="20px">
                <CardCol flex="1 1 50%">
                  <p className="title">Date de disponibilité</p>
                  <p className="txt">
                    {freelance.cdi
                      ? `Votre date de disponibilité n'est pas modifiable car vous êtes actuellement en CDI. Pour pouvoir la modifier, passez votre statut en "consultant" à l'aide de la section "Consultant VS CDI".`
                      :`Indiquez la date à laquelle vous serez disponible pour démarrer une nouvelle mission.`
                    }
                  </p>
                  <AvailabilityDateForm
                    handleDateChange={this.handleDateChange}
                    enableReinitialize={true}
                    initialValues={{freelance}}
                    disabled={freelance.cdi}
                  />
                </CardCol>
                <CardCol flex="1 1 50%">
                  <p className="title">Notifications</p>
                  <p className="txt">
                    <a href={generate({name: 'edit-freelance.alertes'})}>Cliquez-ici</a>{' '}
                    si vous souhaitez modifier vos notifications (mails, SMS) pour les missions.
                  </p>
                </CardCol>
              </CardRow>
            </CardCol>
          </CardRow>
        </div>

        <div className="my-search-container p-5">
          <MySearchExtraForm
            initialValues={this.state.extraFormInitialValues}
            keepDirtyOnReinitialize={false}
            enableReinitialize={true}
            onSubmit={(values) => {
              const {user, freelance} = values

              const city = (user.city)
                ? (user.city.length) ? user?.city?.[0]?.id : user?.city?.id
                : null

              const userData = {
                city: city,
                workCities: user.work_cities.map(city => {return city?.id}),
              }

              const freelanceData = {
                relocation_long_fulltime: freelance.relocation_long_fulltime,
                yearly_brut: freelance.yearly_brut,
                price: freelance.price,
              }

              this.submitUserData(userData)
              this.submitFreelanceData(freelanceData)
            }}
          />
          <p className="text-center mt-5">
            <MySearchExtraFormSubmitButton className="btn btn-primary">Sauvegarder</MySearchExtraFormSubmitButton>
          </p>
        </div>
      </div>
    )
  }
}

export default connectModal(
  {SimpleModal},
  connect(
    state => ({
      mySearchExtraFormValues: getFormValues(MySearchExtraFormName)(state),
      mySearchExtraFormIsDirty: isDirty(MySearchExtraFormName)(state),
    })
  )(MustBeAdminOrBmOrCompletedFreelance(MySearch, false)))
